import { type ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { GridList, type GridListProps } from 'react-aria-components'
import { SkeletonListInfiniteScrollTrigger } from '@/components/SkeletonListInfiniteScrollTrigger'
import { type InfiniteScrollProvider } from '@/infra/InfiniteScrollProvider'
import { AcceptanceListItemSkeleton } from './index'
import styles from './AcceptanceList.module.css'

export interface AcceptanceListContainerProps<T>
  extends Omit<GridListProps<T>, 'children' | 'className'> {
  scroller: InfiniteScrollProvider<T>
  children: (item: T) => ReactNode
  renderEmptyState?: () => ReactNode
}

export const AcceptanceListContainer = observer(
  function AcceptanceListContainer<T extends object>({
    scroller,
    children,
    renderEmptyState,
    ...rest
  }: AcceptanceListContainerProps<T>) {
    if (
      scroller.fetch.resolved &&
      scroller.items.length === 0 &&
      renderEmptyState
    ) {
      return <>{renderEmptyState()}</>
    }

    return (
      <GridList<T> {...rest} className={styles.acceptanceList}>
        {scroller.items.map((item) => children(item))}
        <SkeletonListInfiniteScrollTrigger scroller={scroller} maxSkeletons={1}>
          <AcceptanceListItemSkeleton />
        </SkeletonListInfiniteScrollTrigger>
      </GridList>
    )
  },
)
